<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" :key="error" class="errors">
        {{ error }}
      </p>
    </div>
    <div class="pl-1">
      Using OPA trigger
      <span :class="{'has-error':errors.opaTriggerValue}">
        <select :value="opaTriggerValue" name="opaTriggerValue" class="form-control" @change="handleChange">
          <option value="" disabled>
            Select OPA Trigger
          </option>
          <option v-for="trigger in config.opaTriggerValues" :key="trigger.text" :value="trigger.text">
            {{ trigger.name }}
          </option>
        </select>
      </span>
      <span :class="{'has-error':errors.csnLocation}">
        and encounter CSN located
        <select :value="csnLocation" name="csnLocation" class="form-control" @change="handleChange">
          <option value="" disabled>Select location</option>
          <option v-for="location in config.epicOrderCsnLocations" :key="location.value" :value="location.value">{{ location.label }}</option>
        </select>
      </span>
      <span v-if="csnLocation === 'Variable'" :class="['pl-1', {'has-error':errors.variableId}]">
        select variable:
        <select :value="variableId" name="variableId" class="form-control" @change="handleChange">
          <option value="" disabled>Select Variable</option>
          <option v-for="(variable, vid) in textBasedVariables" :key="vid" :value="vid">{{ variable.name }}</option>
        </select>
      </span>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      opaTriggerValue: String,
      csnLocation: String,
      variableId: [String, Number],
    },
    computed: {
      textBasedVariables() {
        if (!this.config.studyVariablesByType || !this.config.studyVariablesByType.TextBasedVariable) {
          return [];
        }
        return this.config.studyVariablesByType.TextBasedVariable;
      },
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.opaTriggerValue) {
          this.errors.opaTriggerValue = "Please select an OPA Trigger.";
        }

        if (!this.csnLocation) {
          this.errors.csnLocation = 'Please select where the encounter CSN is located.';
        } else {
          if (this.csnLocation === 'Variable' && !this.variableId) {
            this.errors.variableId = 'Please select a variable for the CSN.'
          }
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
